module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM20.7167 14.7649C18.7715 15.574 14.8836 17.2487 9.05318 19.7888C8.10642 20.1653 7.61047 20.5337 7.56532 20.8938C7.489 21.5025 8.25122 21.7422 9.28915 22.0685C9.43033 22.113 9.57663 22.159 9.7266 22.2077C10.7478 22.5397 12.1214 22.928 12.8355 22.9433C13.4833 22.9573 14.2062 22.6903 15.0044 22.1422C20.452 18.465 23.264 16.6063 23.4405 16.5663C23.5652 16.538 23.7377 16.5025 23.8547 16.6064C23.9715 16.7103 23.9602 16.9072 23.9477 16.96C23.8722 17.2818 20.8802 20.0635 19.3318 21.503C18.8492 21.9517 18.5068 22.27 18.4368 22.3427C18.28 22.5057 18.1202 22.6597 17.9667 22.8077C17.018 23.7222 16.3066 24.408 18.006 25.528C18.8228 26.0662 19.4763 26.5112 20.1283 26.9552C20.8403 27.4402 21.5505 27.9238 22.4693 28.5262C22.7035 28.6797 22.927 28.839 23.1448 28.9942C23.9735 29.585 24.718 30.1157 25.6377 30.031C26.1722 29.9818 26.7242 29.4793 27.0045 27.9807C27.667 24.4387 28.9693 16.7642 29.2703 13.6016C29.2968 13.3245 29.2637 12.9699 29.237 12.8143C29.2103 12.6586 29.1547 12.4368 28.9523 12.2727C28.7127 12.0782 28.3428 12.0372 28.1773 12.0401C27.425 12.0534 26.271 12.4547 20.7167 14.7649Z",
      "fill": "black"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdba5da8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/telegram.vue
// module id = 525bea482456d0c9c527
// module chunks = 89